// UploadModalMediaThumbnail.js
import { connect } from 'react-redux';

import UploadModalMediaThumbnail from '../component/UploadModalMediaThumbnail.jsx';

import getAssetData from '../selector/getAssetData.js';
import getMessageThumbnail from '../selector/getMessageThumbnail.js';

import { ArtifactType } from '../resource/assetConstants.js';

const mapStateToProps = (state, { assetId, messageId }) => {
  const messageThumbnail = messageId
    ? getMessageThumbnail(state, messageId, '', '256x256', 'jpg', '')
    : null;
  return {
    contentType: getAssetData(state, [assetId], 'contentType'),
    assetObjectUrl: getAssetData(state, [assetId], 'objectUrl'),
    posterObjectUrl: getAssetData(
      state,
      [assetId, ArtifactType.THUMBNAIL],
      'objectUrl'
    ),
    messageThumbnail,
  };
};

export default connect(mapStateToProps, null)(UploadModalMediaThumbnail);
